import { Plus } from 'lucide-react'
import { QUESTIONS_LIMIT_NOTE } from '../booking-questions-editor.domain'
import { CopyFromMenu } from '../copy-from-menu'
import type { BookingFormHeaderProps } from './booking-form-header.interface'
import classes from './booking-form-header.module.scss'

export function BookingFormHeader({
  headingId,
  canAddQuestion,
  copyMessage,
  copySources,
  onAdd,
  onCopy,
}: BookingFormHeaderProps) {
  return (
    <>
      <div className={classes.header}>
        <h3 id={headingId} className={classes.title}>
          Booking Form
        </h3>
        <div className={classes.actions}>
          <button type="button" className={classes.linkButton} disabled={!canAddQuestion} onClick={onAdd}>
            <Plus size={16} strokeWidth={2.5} aria-hidden="true" />
            Add a question
          </button>
          <CopyFromMenu sources={copySources} onCopy={onCopy} />
        </div>
      </div>
      {!canAddQuestion && <p className={classes.note}>{QUESTIONS_LIMIT_NOTE}</p>}
      {copyMessage && (
        <p className={classes.copyMessage} role="status">
          {copyMessage}
        </p>
      )}
    </>
  )
}
